import {ThreeApp} from "./threejs/ThreeApp";
import {ImageLoader,LoadingManager} from "threejs-full-es6";
import bidello, { component } from 'bidello';
import {NavigationDrawer} from "./componenents/NavigationDrawer";
import {ContentDrawer} from "./componenents/ContentDrawer";
import {Loader} from "./componenents/Loader";

import {States,stateManager,State} from "./services/StateManager";
import {SlideSelector} from "./componenents/SlideSelector";
import {FilterDrawer} from "./componenents/FilterDrawer";
import {ViewBackdrop} from "./componenents/ViewBackdrop";
import {ViewNavigation} from "./componenents/ViewNavigation";
import {assets} from "./services/assets";

class Application extends component() {

    init(){

        this.loadingManager = new LoadingManager(this.onLoaderQueueComplete,this.onLoaderQueueProgress)
        stateManager.setPageStates(window.pagesStates);
        this.backdrop = new ViewBackdrop(document.querySelector("#view-backdrop"))
        this.backdrop.hide();
        const loaderBase = document.head.querySelector("meta[name=base]").getAttribute('url')
        this.threeApp = new ThreeApp();

        this.navigationDrawer = new NavigationDrawer(document.querySelector('#main-navigation'))
        this.contentDrawer = new ContentDrawer(document.querySelector('#content-drawer'))
        this.introSlideSelector = new SlideSelector(document.body.querySelector('#intro-view-selector'));
        this.filterDrawer = new FilterDrawer(document.querySelector('#filter-drawer'))
        this.loader = new Loader(document.querySelector('#assets-loader'))
        this.viewNavigation = new ViewNavigation(document.querySelector('#visit_building_navigation'));
        this.viewNavigation.hide();
        this.loader.showLoader()

    }

    onAssetsLoadComplete (){

        this.loader.hideLoader()
        this.startApp();

    }

    onAssetsLoadProgress (data){

        this.loader.setPercentLoaded(data.progress)

    }

    bindEvent (){

        document.body.addEventListener('click',(e)=>{

            this.mouseInteractionHandler(e);

        })

        document.body.addEventListener('touchend',(e)=>{

            this.mouseInteractionHandler(e);

        })

    }

    mouseInteractionHandler (e){


        if (e.target && e.target.classList.contains('state-change-trigger')){
            const rawStates = e.target.getAttribute('data-state');
            const info = e.target.getAttribute('data-info') || "";
            const url = e.target.getAttribute('href') || e.target.getAttribute('data-href') || "";
            const state = new State(rawStates,url,info);
            state.dispatch();
            e.preventDefault();

        }

    }

    startApp (){

        this.threeApp.run();
        let startState = stateManager.getPagesStateByUrl(window.location.href);
        let state = new State(States.root.DEFAULT_STATE);
        if (startState && startState.state !== ""){
            state = new State(startState.state,"",startState.info);
        }
        state.dispatch();

    }

}

window.addEventListener('DOMContentLoaded',()=>{

    const application = new Application();
    window.app = application
    application.bindEvent();


    let pageUrl = window.location.search.substring(1);
    let pageParams = pageUrl.split("&");
    pageParams.map((param)=>{

        if (param.indexOf("elementor-preview")>=0 || param.indexOf("preview_id")>=0) {

            window.app.contentDrawer.open();

        }

    })

})